import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import Translator from './../../../requests/apa/Translator';
import Device from '../../../devices/device';
import Assets from './../../../requests/apa/Asset';
import api from './../../requests/api/';
import './_styles.scss';
import { Player } from '../VcardTeam/player';
import Utils from 'src/utils/Utils';

class VcardCoach extends Component<RouteComponentProps> {
    constructor(props: any) {
        super(props);
        this.onKeyPress = this.onKeyPress.bind(this);
    }
    public keys = (Device.getDevice() && Device.getDevice().getKeys()) || null;
    state = {
        imgBackground: null,
        coachData: {
            playerImage: '',
            playerName: '',
            birthPlaceValue: '',
        },
        apaData: {
            placeBirthText: '',
        },

        teamData: {
            teamAbbreviation: '',
            teamName: '',
        },
    };

    onKeyPress(e: any): void {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        if (currentKey === 'BACK') {
            const { history } = this.props;
            history.goBack();
        }
    }

    private getApaData() {
        this.setState({
            apaData: {
                placeBirthText: Translator.get(
                    'talent_detail_placeBirth_label',
                    'Lugar de Nacimiento'
                ),
            },
        });
    }

    private async getCoachData() {
        const {
            match: {
                params: { teamId, coachId },
            },
        } = this.props;
        const data = await api.getCoach(teamId, coachId);
        const { name, image, dateOfBirth } = data.coach;
        const { name: teamName, nameAbbrev } = data.team;

        this.setState({
            coachData: {
                playerImage: image,
                playerName: name,
                birthPlaceValue: dateOfBirth
            },
            teamData: {
                teamName,
                teamAbbreviation: nameAbbrev
            },
        });
    }

    componentDidMount() {
        this.getCoachData();
        this.getApaData();
        document.querySelector('.coach-main-container')?.scrollIntoView();
        Utils.setInitialFocus('#director-name')
        document.addEventListener('keydown', this.onKeyPress, true);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.onKeyPress, true);
    }

    private imgBackground() {
        const urlImg = Assets.get('talent_player_detail_header_img');
        return <img src={urlImg} alt={urlImg} />;
    }

    private transformImg () {
        document.querySelector('.first-container-director')?.scrollIntoView()
    }

    public render(): React.ReactNode {
        const { placeBirthText } = this.state.apaData;

        const { playerName, playerImage, birthPlaceValue } = this.state.coachData;

        const { match: { params: { teamId, coachId } } } = this.props;
        const { teamAbbreviation, teamName } = this.state.teamData;

        const ribbonData = {
            idTeam: teamId,
            title: Translator.get('talent_player_detail_title_ribbon_players_label'),
            idPlayer: coachId,
        };

        const coverImageStyles = {
            backgroundImage: `url(${playerImage})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
        }
        
        return (
            <span className="container-director-header">
                <div className="coach-main-container">
                    <div className="first-container-director" style={{ backgroundImage: `url(${Assets.get('talent_player_detail_header_img')})` }}/>
                    <div className="cont-img">
                        <div className="box-img">
                            <a
                                data-sn-left=''
                                href=""
                                id="director-name"
                                className="focusable"
                                onFocus={this.transformImg}
                                onClick={(e) => {
                                    e.preventDefault();
                                }}
                                target="_blank"
                            >
                                {playerImage &&  
                                    <button 
                                        className="img-focusable" 
                                        style={coverImageStyles}
                                        onClick={(e) => {
                                            e.preventDefault();
                                        }}>
                                    </button>
                                }
                            </a>
                        </div>
                        <div className="name">
                            <span>{playerName}</span>
                        </div>
                        {birthPlaceValue !== '' &&
                            (
                                <div className="place-birth">
                                    <span className="place-birth_title">{`${placeBirthText}`}</span>
                                    <span className="place-birth_value">{` ${birthPlaceValue}`}</span>
                                </div>
                            )
                        }
                        <div className="team">
                            <span className="team_abr">{teamAbbreviation}</span>
                            <span>{` | ${teamName}`}</span>
                        </div>
                    </div>
                </div>
                <Player playerData={ribbonData} {...this.props} />
            </span>
        );
    }
}

export default VcardCoach;



// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardDirector/index.tsx